import navBar from './shared-components/nav-bar/index.mjs';
import footer from './shared-components/custom-footer/index.mjs';
import signUp from './shared-components/sign-up/index.mjs';

/** Wait until the custom element is defined & rendered once */
async function getSignUp() {
  await customElements.whenDefined('sign-up');
  const el = document.querySelector('sign-up');
  // Ensure it has rendered; its connectedCallback renders immediately,
  // but raf gives us a safe tick for shadow contents to exist.
  await new Promise((r) => requestAnimationFrame(r));
  return el;
}

document.addEventListener('DOMContentLoaded', async () => {
  // Add event for the jam button
  const signUp = await getSignUp();
  if (!signUp) return;

  // ——— 1) “Sign Up for Lessons!” button in the contact card
  const cardSignupBtn = document.getElementById('jam-btn');
  if (cardSignupBtn) {
    cardSignupBtn.addEventListener('click', () => openSignUp(signUp));
  }
});

function openSignUp(signUp) {
  if (typeof signUp.open === 'function') {
    signUp.open();
  } else {
    // fallback: toggle the class in shadow (shouldn't be needed)
    const panel = signUp.shadowRoot?.getElementById('contact-slide-panel');
    panel?.classList.add('open');
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const siteTitle = document.getElementById('site-title');
  const flyingGuitar = document.getElementById('flying-guitar');
  const rockOn = document.getElementById('rock-on');
  const flameEffect = document.querySelector('.flame-effect');
  let isAnimating = false;

  siteTitle.addEventListener('click', function(e) {
    if (isAnimating) return;
    isAnimating = true;

    // Start guitar and rock-on animations immediately
    flyingGuitar.classList.add('animate');
    rockOn.classList.add('animate');
    flameEffect.classList.add('animate');

    // Reset after animation completes
    setTimeout(() => {
      flyingGuitar.classList.remove('animate');
      rockOn.classList.remove('animate');
      flameEffect.classList.remove('animate');
      isAnimating = false;
    }, 5000);
  });
});
